'use strict';

var cos_hoverIntent = (function (dataObject) {
    var self = this,
        selfProto = cos_hoverIntent.prototype,
        inMenuTimmer,
        currentMenu,
        lastMenu,
        inMenu = false,
        allMenus = $(dataObject.sub),
        ParentMenu = $(dataObject.main),
        mouseOverIntent = { userMouse: false, currentMenu: null },
        startPoints = {
            x: 0,
            y: 0,
            t: Date.now()
        },
        slow = false,
        mouseNumber = {
            dividend: 1000,
            divisor: 100
        },
        intervalNumber = dataObject.intervalNumber || 100;
    if (dataObject.mouseNumber) {
        dataObject.mouseNumber.dividend !== undefined ? mouseNumber.dividend = dataObject.mouseNumber.dividend : null;
        dataObject.mouseNumber.divisor !== undefined ? mouseNumber.divisor = dataObject.mouseNumber.divisor : null;
    }

    selfProto.checkMenuIntent = function () {
        function isHovering() {
            clearTimeout(inMenuTimmer);
            inMenuTimmer = setTimeout(self.addDisplayClass, 100);
        }
        if (currentMenu !== null && currentMenu.length > 0) {
            var srt_0 = currentMenu[0].innerText,
                str_1 = mouseOverIntent.currentMenu[0].innerText
            srt_0 === str_1 ? isHovering() : null;
        }
    }
    selfProto.addDisplayClass = function () {

        if (mouseOverIntent.userMouse && slow) {
            clearTimeout(inMenuTimmer);
            self.unloadMenu();
            mouseOverIntent.currentMenu.parent().addClass(dataObject.class);
            if(dataObject.siblingsClass) {
                mouseOverIntent.currentMenu.parent().siblings().addClass(dataObject.siblingsClass);
            }
            lastMenu = currentMenu;
            inMenu = true;
        }

    }
    selfProto.unloadMenu = function () {
        allMenus.parent().siblings().removeClass(dataObject.siblingsClass);
        allMenus.parent().removeClass(dataObject.class);
        inMenu = false;
    }
    selfProto.loadMenu = function (event) {
        mouseOverIntent.userMouse = true;
        mouseOverIntent.currentMenu = $(event.target);
    }
    selfProto.setup = function () {
        ParentMenu.on('mousemove', dataObject.sub, function (event) {
            function makeVelocityCalculator(e, callback) {
                var newPoints = {
                    x: e.clientX,
                    y: e.clientY,
                    t: Date.now()
                },
                    x_dist = newPoints.x - startPoints.x,
                    y_dist = newPoints.y - startPoints.y,
                    interval = newPoints.t - startPoints.t;
                // update values:
                startPoints.x = newPoints.x;
                startPoints.y = newPoints.y;
                startPoints.t = newPoints.t;
                var velocity = Math.sqrt(x_dist * x_dist + y_dist * y_dist) / interval;
                callback(velocity);

            }
            makeVelocityCalculator(event, function (v) {
                slow = false;
                if ((v * mouseNumber.dividend) < mouseNumber.divisor) {
                    $(event.target).mouseenter();
                    slow = true;
                    inMenu = false;
                    self.checkMenuIntent();
                }
            });
        }).on('mouseenter', dataObject.sub, function (event) {
            currentMenu = $(event.target);
            lastMenu !== currentMenu && !inMenu ? self.loadMenu(event) : null;

        }).on('mouseleave', function (event) {
            clearTimeout(inMenuTimmer);
            mouseOverIntent.userMouse = false;
            inMenuTimmer = setTimeout(self.unloadMenu, intervalNumber);
        }).on('tap', dataObject.sub, function (event) {
            slow = true;
            inMenu = false;
            $(event.target).mouseenter();
            self.checkMenuIntent();
        }).on('tap', function (event) {
            mouseOverIntent.userMouse = false;
            self.unloadMenu();
        })
    }

    return {
        setup: self.setup
    }
});

var delayedMenuHover = (function (blackBarNav) {
    var self = this, selfProto = delayedMenuHover.prototype,
        isPaused = false,
        isclicked = false,

        hoverIntentEvents={
            enterBlackBar: (function (e) {
                clearTimeout(self.inverval);
                var target
                $.each(blackBarNav.classes.parentClass, function (k, v) {
                    target = $(e.target).closest('.' + v);
                    target.length !== 0 ? self.checkMenu(target) : null;
                });
                isPaused = false;
                self.lastTarget = target;
            }),
            exitBlackBar: (function (e) {
                var s = blackBarNav.pauseAreas,
                    ss = s.split(",");
                for (var i in ss) {
                    (ss[i] == $(e.target)[0].tagName.toLowerCase() && $(e.target).is(':focus'))? isPaused = true : null;
                }
                isPaused ? null : self.inverval = setTimeout(self.exitMenu, 500, e);
            })
        }


    selfProto.inverval = setTimeout(null, 0);
    selfProto.lastTarget = null;
    selfProto.overWatch = false;

    selfProto.exitMenu = function (e) {

        var currentTarget = e === self.lastTarget?currentTarget = self.lastTarget:currentTarget = $(e.target) ,
        s = blackBarNav.pauseAreas,
            ss = s.split(",");
        for (var i in ss) {
            if(currentTarget.length!==0) {
                if(ss[i] == currentTarget[0].tagName.toLowerCase() && currentTarget.is(':focus')) {
                    isPaused = true;
                };
            }
        }
        if (!isPaused) {
            currentTarget.closest('.' + blackBarNav.classes.active).removeClass(blackBarNav.classes.active);
        }

    }
    selfProto.checkMenu = function (target) {
        clearTimeout(self.inverval);
        if (!target.hasClass(blackBarNav.classes.active)) {
            $('.' + blackBarNav.classes.active).removeClass(blackBarNav.classes.active);
            target.attr(blackBarNav.id) ?
                target.find("." + blackBarNav.classes.subMenuClass).addClass(blackBarNav.classes.active) :
                target.addClass(blackBarNav.classes.active);

        };

    }
    selfProto.reset = (function () {
        isPaused = false;
        isclicked = false;
        self.exitMenu(self.lastTarget);
        self.overWatch = false;
    });

    selfProto.setup = (function () {
        $(blackBarNav.mainElement).hoverIntent(hoverIntentEvents.enterBlackBar, hoverIntentEvents.exitBlackBar);

        $(blackBarNav.parentContainer).on('mousedown', blackBarNav.mainElement + " " + blackBarNav.pauseAreas, function (event) {
            isPaused = true;
            isclicked = true;
        });
        $(blackBarNav.parentContainer).on('mouseup', function (event) {
            isPaused = false;
            isclicked = false;
        });
        $(blackBarNav.parentContainer).on('mousemove', function (event) {
            function overWatch(){
                !self.overWatch ? self.interval = setTimeout(self.reset, 5000) :null;
                self.overWatch = true;
            }
            isclicked ? overWatch():null;
        });
    });
    return {
        setup: self.setup
    }
})
module.exports = {MainMenu:cos_hoverIntent,customeMenu:delayedMenuHover};